import axios from 'axios';

export const getAllResponses = patientFhirId => {
    return axios.get(`/fhir/QuestionnaireResponse?_sort=-authored&patient=${patientFhirId}`, { headers: { 'Cache-Control': 'no-cache' } });
};

export const getAllResponsesPaging = path => {
    return axios.get(`${path}`);
};
